import React from "react";
import { useNavigate } from "react-router-dom";

import {
  listPlanOrderStates,
  listPlanOrganizations,
  listPlanOrders,
} from "@/api/order_plan";
import { OrdersList } from "@/pages/order-check/OrdersList";

/**
 * Раскладка паллет — точка входа раздела.
 *
 * Список, фильтры и поиск общие с проверкой заказов (`OrdersList`): это один
 * и тот же список заказов, и вторая копия разъехалась бы с первой.
 *
 * ⚠️ Ручки СВОИ, а не чужие: у раздела своё право (`order_plan`), и человек с
 * ним одним получил бы от ручек проверки заказов 403 — список и фильтры не
 * наполнились бы МОЛЧА. Тот же урок, что с конфигом раздела коробок.
 */
export function OrderPlanListPage(): React.ReactElement {
  const navigate = useNavigate();
  return (
    <OrdersList
      title="Раскладка паллет"
      subtitle="Сверка раскладки с заказом и ручная перекладка по паллетам."
      lsPrefix="wh_plan"
      queryKey="order-plan"
      api={{
        list: listPlanOrders,
        organizations: () => listPlanOrganizations(),
        states: () => listPlanOrderStates(),
      }}
      onOpen={(o) => navigate(`/order-plan/orders/${o.ref}`)}
    />
  );
}
